import React, { ReactNode } from 'react';

import { IconWrapper, ItemHeading, ItemDescription } from './StyledDetailWithIcon';

type ItemProps = {
  title: string;
  description: ReactNode;
  icon: React.ElementType;
};

const Item: React.FC<ItemProps> = ({ title, description, icon: Icon }) => (
    <React.Fragment>
      <IconWrapper>
        <Icon title={title} />
      </IconWrapper>
      <ItemHeading>{title}</ItemHeading>
      <ItemDescription>{description}</ItemDescription>
    </React.Fragment>
  );

export default Item;
